var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.375C4.68477 0.375 0.375 4.68477 0.375 10C0.375 15.3152 4.68477 19.625 10 19.625C15.3152 19.625 19.625 15.3152 19.625 10C19.625 4.68477 15.3152 0.375 10 0.375ZM10 17.9922C5.58711 17.9922 2.00781 14.4129 2.00781 10C2.00781 5.58711 5.58711 2.00781 10 2.00781C14.4129 2.00781 17.9922 5.58711 17.9922 10C17.9922 14.4129 14.4129 17.9922 10 17.9922Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 9.3125H10.6875V6.04688C10.6875 5.95234 10.6102 5.875 10.5156 5.875H9.48438C9.38984 5.875 9.3125 5.95234 9.3125 6.04688V9.3125H6.04688C5.95234 9.3125 5.875 9.38984 5.875 9.48438V10.5156C5.875 10.6102 5.95234 10.6875 6.04688 10.6875H9.3125V13.9531C9.3125 14.0477 9.38984 14.125 9.48438 14.125H10.5156C10.6102 14.125 10.6875 14.0477 10.6875 13.9531V10.6875H13.9531C14.0477 10.6875 14.125 10.6102 14.125 10.5156V9.48438C14.125 9.38984 14.0477 9.3125 13.9531 9.3125Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.06f8d0e40afdc699de6ac3b009ef8e07.svg";
export { ForwardRef as ReactComponent };